import dayjs from 'dayjs'
import { scrollAnimation } from '../../../utils/scroll-handler'
import { getEmail, getToken } from '../../../api/service/user'

export function scrollToReviews() {
  scrollAnimation(
    // @ts-ignore
    document.querySelector<HTMLDivElement>('.reviews-wrapper')?.offsetTop -
      88 || 0
  )
}
// 解析被加密的字符串
export const parseFn = (str: string) => {
  try {
    const res = JSON.parse(decodeURIComponent(window.atob(str)))
    if (typeof res === 'object' && Array.isArray(res)) {
      return res
    }
    return []
  } catch (e) {
    return []
  }
}

// 获取储存到LocalStorage的评论
export const getLocalReviews = () => {
  const localReview = window.localStorage.getItem('posted_rvs')
  // console.log('reviewCache', parseFn(localReview))
  return localReview && localReview !== 'undefined' ? parseFn(localReview) : []
}

//  获取两小时内发布的评论：
// （如果已登录，还要匹配登录账号对应的已发布评论）
// （如果传入productHandle，还要匹配handle对应的已发布评论）
export const get2HoursLocalReviews = (productHandle?: string) =>
  getLocalReviews().filter(
    (r: any) =>
      dayjs(r.createdAt).add(2, 'hour').isAfter(dayjs()) &&
      (getToken() ? r.reviewerEmail === getEmail() : true) &&
      (productHandle ? r.productHandle === productHandle : true)
  )

// 储存评论到LocalStorage，顺便清除已过期的评论
export function saveReview(review: any) {
  // eslint-disable-next-line no-param-reassign
  review = Array.isArray(review) ? review : [review]
  // console.log('review ', review)
  let reviewCache = get2HoursLocalReviews()
  // console.log('reviewCache ', reviewCache)
  reviewCache = [...review, ...reviewCache]
  window.localStorage.setItem(
    'posted_rvs',
    window.btoa(encodeURIComponent(JSON.stringify(reviewCache)))
  )
}
